import request from '@/utils/request'
/* 获取分享人列表接口 */
export function getSharesPage(data) {
  return request({
    url: '/admin/sharers/page',
    method: 'get',
	  params:data
  })
}

/* 获取分享人统计接口 */
export function getSharesCount(data) {
  return request({
    url: '/admin/sharers/count',
    method: 'get',
      params:data
  })
}

/* 获取提现记录接口 */
export function getSharesCashout(data) {
  return request({
    url: '/admin/sharers/withdraw-record/page',
    method: 'get',
      params:data
  })
}

/* 获取电梯广告推广接口 */
export function getAddtSharesRecord(data) {
  return request({
    url: '/admin/sharers/adshare/page',
    method: 'get',
    params:data
  })
}

/* 获取分享人统计接口 */
export function getSharesCashoutCount(data) {
  return request({
    url: '/admin/sharers/withdraw-record/count',
    method: 'get',
      params:data
  })
}

/* 获取团队名单 */
export function getSharesUsersPage(data) {
  return request({
    url: '/admin/sharers/users/page',
    method: 'get',
	  params:data
  })
}

/* 获取团队订单 */
export function getSharesOrdersPage(data) {
  return request({
    url: '/admin/sharers/orders/page',
    method: 'get',
	  params:data
  })
}
